import ColoredText from './coloredtext';

nn.component.ColoredText = function(element){
  return new ColoredText(element);
};